import { useEffect } from 'react';
import Snowfall from 'react-snowfall';
import onWord from 'views/easter-eggs/utils/on-word';
import snowflakeSourceImg from '../assets/snowflake-blu-viu-25.png';
import { SnowfallContextProvider, useSnowfallState } from '../context/snowfall-context';
import { useSnowfallSettings } from '../hooks/use-snowfall-settings';

const snowflake = document.createElement('img');
snowflake.src = snowflakeSourceImg;

const images = [snowflake];

const SnowfallViewer = () => {
  const {
    snowfallSettings: { color, snowflakeCount, radius, speed, wind, useImages },
  } = useSnowfallSettings();
  const { showSnowfall, toggleSnowfall } = useSnowfallState();

  useEffect(() => {
    const { cleanUp } = onWord('christmas', () => {
      console.log('Happy holidays!');
      // toggleSnowfall();
    });
    return cleanUp;
  }, []);

  useEffect(() => {
    const { cleanUp } = onWord('jul', () => {
      console.log('God Jul!');
      // toggleSnowfall();
    });
    return cleanUp;
  }, []);

  useEffect(() => {
    const { cleanUp } = onWord('navidad', () => {
      console.log('¡Feliz Navidad!');
      // toggleSnowfall();
    });
    return cleanUp;
  }, []);

  if (!showSnowfall) return;

  return (
    <Snowfall
      style={{
        zIndex: 99999,
        pointerEvents: 'none',
      }}
      color={color}
      snowflakeCount={snowflakeCount}
      images={useImages ? images : undefined}
      radius={radius}
      speed={speed}
      wind={wind}
    />
  );
};

const SnowfallContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <SnowfallContextProvider>
      <SnowfallViewer />
      {children}
    </SnowfallContextProvider>
  );
};

export default SnowfallContainer;
